import { isPremium } from '../services/Wix';
import _ from 'lodash';
import shared from '../../shared/';
import createBadgeContainer from './createBadgeContainer';

import './badges.css';

export const badgesList = shared.badgesList.map(function(badge) {
  return Object.assign({}, badge, {
    BadgeComponent: createBadgeContainer(badge.BadgeComponentStateless)
  });
});

export const badgesById = badgesList.reduce(
  (memo, badge) => {
    memo[badge.id] = badge;
    return memo;
  },
  {}
);

export function getDefaultBadgeId() {
  return _.find(badgesList, ({ isDefault }) => isDefault).id;
}

// get the selected badgeId or the default badgeId
export function getNormalizedBadgeId(badgeId) {
  if (!isPremium() && badgesById[badgeId].premium) {
    return getDefaultBadgeId();
  }

  return badgeId;
}



// WEBPACK FOOTER //
// ./src/commons/badges/index.js